import base from '../base'
import { postJsonRequest, postRequest } from '@utils/request'
const cloud = `prescription/${base.appCode}`

const USER = {
  // 获取登录图像验证码
  getVerCode(params) {
    return postRequest(`${base.baseUrl}/${cloud}/api/account/operation/manage/v1/vercode`, params)
  },
  // 去登录
  toLogin(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/operation/manage/v1/login`, params)
  },
  // 退出登录
  logout(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/operation/manage/v1/logout`, params)
  },
  // 角色相关接口
  // 角色列表
  roleList(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/paginglist`, params)
  },

  // 权限-账号管理-所属角色
  getAuthFilterRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/account/filter/roleBySelf`, params)
  },

  // 权限-角色列表
  getAuthRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/role/paginglist`, params)
  },

  // 编辑保存角色
  editRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/save`, params)
  },

  // 权限-药商编辑保存角色
  saveAuthEditRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/role/save`, params)
  },

  // 角色详情
  getRoleDetail(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/detail`, params)
  },

  // 权限-药商角色详情
  getAuthRoleDetail(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/role/detail`, params)
  },

  // 权限-平台角色详情
  getAuthAccountDetail(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/detail`, params)
  },

  // 删除角色
  delRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/delete`, params)
  },

  // 权限-删除角色
  saveAuthDelRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/role/delete`, params)
  },

  // 账户相关操作
  // 账户列表
  getAccountList(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/paginglist`, params)
  },
  // 删除账户
  delAccount(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/batch/delete`, params)
  },
  // 权限-删除账户
  saveAuthDelAccount(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/pharmace/batch/delete`, params)
  },

  // 账户详情
  getAccountDetail(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/detail`, params)
  },
  // 保存账号信息
  saveAccount(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/save`, params)
  },
  // 权限-保存账号信息
  saveAuthAccount(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/pharmace/save`, params)
  },
  // 权限相关接口
  // 根据角色集合 获取权限列表
  getAuthByRoleIds(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/auth/manage/v1/getauthbyroleids`, params)
  },
  // 登录用户相关接口
  // 用户基本设置
  accountSetting(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/account/manage/v1/setting`, params)
  },
  // 获取全部设置权限
  getAllAuth(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/auth/manage/v1/getauthbyisdefaults`, params)
  },
  // 获取权限配置项
  getAdminAuth(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/auth/manage/v1/getAuthListByUserId`, params)
  },
  // 根据自己角色查询角色列表
  getSelfRole(params) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/role/manage/v1/roleBySelf`, params)
  }
}

export default USER



// WEBPACK FOOTER //
// ./src/api/modules/user.js